import { useContext, useEffect, useState } from "react";
import {
  createJiraIssues,
  exportBugReportToJira,
  getAllJiraFields,
  getAllProjects,
  updateJiraIssues,
} from "../../../../services/webServices";
import JiraProjectsComponentPage from "../../../common-components/JiraProjectsComponentPage";
// import FieldMapper from "../../../common-components/FieldMapper";
import { LoadingModalContext, MessagePopupContext } from "../../ServicePage";

export const JiraExport = ({
  taskType,
  issueType,
  setJiraPageOpen,
  exportData,
  almConfig,
}) => {
  const [projectsList, setProjectsList] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [proceedingMap, setProceedingMap] = useState(null);
  const [importLoading, setImportLoading] = useState(null);

  const { setMessagePopup, setMessage } = useContext(MessagePopupContext);
  const { setLoadingState } = useContext(LoadingModalContext);

  // Fetch Jira projects
  useEffect(() => {
    const fetchProjects = async () => {
      setImportLoading("Projects");
      try {
        const response = await getAllProjects();
        setProjectsList(response.data);
      } catch (error) {
        console.error("Error fetching Jira projects:", error);
        setMessage("Failed to fetch Jira projects");
        setMessagePopup(true);
      } finally {
        setImportLoading(null);
      }
    };

    fetchProjects();
  }, []);

  useEffect(() => {
    if (selectedProject) {
      handleExport();
    }
  }, [selectedProject]);

  const getMappedData = (issues) => {
    return issues.map((issue) => {
      const mapped = {};
      mapped.id = issue.id || null;
      mapped.key = issue.key || null;
      Object.entries(proceedingMap.mapping).forEach(([key, value]) => {
        if (value) {
          mapped[value.key] =
            (mapped[value.key] || "") +
            (mapped[value.key] ? "\n\n" : "") +
            issue[key];
        }
      });
      return mapped;
    });
  };

  const handleExport = async () => {
    if (exportData.every((eachUserStory) => !eachUserStory)) {
      setMessage("Select at least one issue to export");
      setMessagePopup(true);
      return;
    }

    setLoadingState({
      open: true,
      message: `Exporting ${issueType}`,
      progress: null,
    });

    try {
      const payload = {
        projectName: selectedProject.name,
        projectKey: selectedProject.key,
        issueType,
        exportData
      };

      if (
        !!almConfig &&
        almConfig.toolName === "Jira" &&
        almConfig.issueType === issueType &&
        almConfig.projectName === selectedProject.name
      ) {
        await updateJiraIssues(payload);
        setMessagePopup(true);
        setMessage("Issues updated successfully.");
      } else {
        await createJiraIssues(payload);
        setMessage("Issues exported successfully.");
        setMessagePopup(true);
      }
      // Stop loader before showing popup
      setMessagePopup(true);
    } catch (error) {
      console.error(error);
      setMessage("An unexpected error occurred during export");
      setMessagePopup(true);
    } finally {
      setLoadingState({ open: false, message: "", progress: null });
      setJiraPageOpen(false);
    }
  };

  return (
    <div>
      {/* Project selection */}
      {!selectedProject && (
        <JiraProjectsComponentPage
          taskType={taskType}
          issueType={issueType}
          projectsLoading={importLoading === "Projects"}
          setOpenProjectPage={setJiraPageOpen}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
          projectsList={projectsList}
        />
      )}

      {/* Field mapping */}
      {/* {selectedProject && !proceedingMap && (
        <FieldMapper
          importMapAvailable={!!almConfig && almConfig.toolName === "Jira" && almConfig.issueType === issueType}
          oldMapping={almConfig ? almConfig.fieldMapping : null}
          taskType="Export"
          setProceedingMap={setProceedingMap}
          setALMModalOpen={setJiraPageOpen}
          setPreviousSelection={setSelectedProject}
          toolName="Jira"
          projectName={selectedProject.name}
          issueType={issueType}
          getAvailableFields={handleAvailableFields}
        />
      )} */}
    </div>
  );
};
